class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = null;
    this.maxPageWidth = parseFloat(
      getComputedStyle(
        this.closest('.shopify-section')
      ).getPropertyValue('max-width')
    );

    this.resizeObserver = null;
  }

  connectedCallback() {
    this.slider = this.initMainSlider();

    if (
      this.querySelector(
        '[data-ref="thumbnail-slider"]'
      )
    ) {
      this.thumbnailSlider =
        this.initThumbnailSlider();
    }

    if (this.thumbnailSlider) {
      this.slider.sync(this.thumbnailSlider);
    }

    this.slider.mount();

    if (this.thumbnailSlider) {
      this.thumbnailSlider.mount();
    }

    if (!this.thumbnailSlider) {
      this.slider.on('mounted', () => {
        this.updateSize();
      });

      /*
       * Utiliser ResizeObserver pour détecter
       * tous les changements de taille.
       */
      this.resizeObserver = new ResizeObserver(
        () => {
          this.updateSize();
        }
      );

      this.resizeObserver.observe(
        document.documentElement
      );
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    if (this.slider) {
      this.slider.destroy();
    }

    if (this.thumbnailSlider) {
      this.thumbnailSlider.destroy();
    }
  }

  initMainSlider() {
    const perPageDesktop =
      this.getAttribute(
        'data-per-page-desktop'
      );

    let perPageMobile =
      this.getAttribute(
        'data-per-page-mobile'
      );

    const perPageTabletAttribute =
      this.getAttribute(
        'data-per-page-tablet'
      );

    /*
     * Vetëm sliderët që kanë atributin
     * data-per-page-tablet do të përdorin
     * breakpoint-in e ri për tablet.
     *
     * Sliderët e tjerë, si bannerët dhe
     * product gallery, vazhdojnë si më parë.
     */
    const hasTabletSetting =
      perPageTabletAttribute !== null &&
      perPageTabletAttribute !== '';

    const perPageTablet =
      hasTabletSetting
        ? perPageTabletAttribute
        : perPageDesktop;

    const gap =
      this.getAttribute('data-gap') + 'px';

    const showArrows =
      this.getAttribute(
        'data-show-arrows'
      ) === 'true';

    const showArrowsMobile =
      this.getAttribute(
        'data-show-arrows-mobile'
      ) === 'true';

    const showPagination =
      this.getAttribute(
        'data-show-pagination'
      ) === 'true';

    const showPaginationMobile =
      this.getAttribute(
        'data-show-pagination-mobile'
      ) === 'true';

    const autoplay =
      this.getAttribute(
        'data-autoplay'
      ) === 'true';

    const autoplaySpeed =
      this.getAttribute(
        'data-autoplay-speed'
      ) + '000';

    const rewind =
      this.getAttribute(
        'data-rewind'
      ) === 'true';

    if (perPageMobile === '1.8') {
      perPageMobile = 1;
    }

    /*
     * Konfigurimi origjinal për sliderët
     * që nuk kanë setting për tablet.
     */
    let sliderBreakpoints = {
      750: {
        perPage: perPageDesktop,
        pagination: showPagination,
        arrows: showArrows,
      },
    };

    /*
     * Konfigurimi i ri aplikohet vetëm kur
     * ekziston data-per-page-tablet.
     *
     * Mobile: 0–749px
     * Tablet: 750–989px
     * Desktop: 990px+
     */
    if (hasTabletSetting) {
      sliderBreakpoints = {
        750: {
          perPage: perPageTablet,
          pagination: showPagination,
          arrows: showArrows,
        },
        990: {
          perPage: perPageDesktop,
          pagination: showPagination,
          arrows: showArrows,
        },
      };
    }

    return new Splide(
      this.querySelector(
        '[data-ref="main-slider"]'
      ),
      {
        perPage: perPageMobile,
        perMove: 1,
        rewind: rewind,
        gap: gap,
        drag: true,
        snap: true,
        arrows: showArrows,
        arrowsMobile: showArrowsMobile,
        pagination: showPaginationMobile,
        autoplay: autoplay,
        interval: autoplaySpeed,
        autoHeight: true,
        lazyLoad: false,
        flickMaxPages: 1,
        flickPower: 400,
        mediaQuery: 'min',
        breakpoints: sliderBreakpoints,
      }
    );
  }

  initThumbnailSlider() {
    const showArrows =
      this.getAttribute(
        'data-show-arrows-thumbnails'
      ) === 'true';

    return new Splide(
      this.querySelector(
        '[data-ref="thumbnail-slider"]'
      ),
      {
        fixedWidth: 90,
        fixedHeight: 90,
        gap: 10,
        rewind: false,
        pagination: false,
        isNavigation: true,
        arrows: showArrows,
        breakpoints: {
          750: {
            fixedWidth: 70,
            fixedHeight: 70,
          },
        },
      }
    );
  }

  updateSize() {
    this.pageWidth =
      document.documentElement.clientWidth;

    this.sectionPadding = parseFloat(
      getComputedStyle(
        this.closest('.shopify-section')
      ).getPropertyValue('padding-right')
    );

    let padding = this.sectionPadding;

    if (this.pageWidth > this.maxPageWidth) {
      padding =
        (this.pageWidth - this.maxPageWidth) / 2 +
        this.sectionPadding;
    }

    this.style.width =
      `calc(100% + ${2 * padding}px)`;

    this.style.marginLeft =
      `-${padding}px`;

    this.style.marginRight =
      `-${padding}px`;

    const sliderTrack =
      this.querySelector('.splide__track');

    if (sliderTrack) {
      sliderTrack.style.paddingRight =
        `${padding}px`;

      sliderTrack.style.paddingLeft =
        `${padding}px`;
    }

    const previousArrow =
      this.querySelector(
        '.splide__arrow--prev'
      );

    const nextArrow =
      this.querySelector(
        '.splide__arrow--next'
      );

    if (previousArrow && nextArrow) {
      previousArrow.style.left =
        `${padding + 10}px`;

      nextArrow.style.right =
        `${padding + 10}px`;
    }
  }

  remove(index) {
    this.slider.remove(index);
  }
}

if (
  !customElements.get('slider-component')
) {
  customElements.define(
    'slider-component',
    SliderComponent
  );
}